import { gql } from '@apollo/client';
import type { InhubSortingDimension } from './getInhubSortingAccountSummariesPage';

export const GET_INHUB_SORTING_DETAIL_PAGE = gql`
  query GetInhubSortingDetailPage($filter: InhubSortingDetailInput!) {
    getInhubSortingDetailPage(filter: $filter) {
      content {
        trackingNumber
        orderId
        overallStatus
        bagNumber
        sortingCode
        accountName
        laborTeamName
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export type InhubSortingMetric =
    | 'INBOUND_COUNT'
    | 'BAGGING_COUNT'
    | 'LOADING_PARCEL_COUNT'
    | 'WRONG_ROUTE_BAGGING_COUNT'
    | 'WRONG_SORT_COUNT'
    | 'ASCAN_MISS_COUNT'
    | 'TRANSIT_IN_MISS_COUNT';

export interface InhubSortingDetailInput {
    hubId: number;
    rangeStart: string;
    rangeEnd: string;
    dimension: InhubSortingDimension;
    groupKey?: number | null;
    accountName?: string | null;
    // TEAM 维度点击具体队伍时透传：数仓同名多 laborTeamId 会在汇总层合并为一行，
    // 只传 groupKey 拉不到全部明细；后端拿 laborTeamName 反向解析 id 集合走 inList。
    // 空/null（含"未分组"桶点击）走原未分组桶回溯逻辑。
    laborTeamName?: string | null;
    metric: InhubSortingMetric;
    page?: number;
    pageSize?: number;
    // KPI 卡数字下钻传 true：忽略 groupKey/未分组桶过滤，返回该指标 hub+时间窗内全量明细
    matchAllGroups?: boolean;
}

export interface InhubSortingDetailRowResp {
    trackingNumber: string;
    orderId: number | null;
    overallStatus: string;
    bagNumber: string;
    sortingCode: string;
    accountName: string;
    laborTeamName: string;
}

export interface GetInhubSortingDetailPageResponse {
    getInhubSortingDetailPage: {
        content: InhubSortingDetailRowResp[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}
